import React, { useState } from "react";
import api from "@/lib/api";
import { Field, Input, Button, Textarea } from "@/components/UI";
import { Plus } from "@phosphor-icons/react";
import { toast } from "sonner";


export function QuickPurchaseModal({ item, onClose, onDone }) {
  const [quantity, setQuantity] = useState("");
  const [price, setPrice] = useState(String(item.unit_price ?? ""));
  const [supplier, setSupplier] = useState(item.supplier || "");
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  const qtyNum = Number(quantity || 0);
  const priceNum = Number(price || 0);
  const cost = Number((qtyNum * priceNum).toFixed(2));
  const newQty = Number(item.quantity || 0) + qtyNum;
  const priceChanged = priceNum > 0 && Math.abs(priceNum - Number(item.unit_price || 0)) > 1e-9;

  const submit = async (e) => {
    e.preventDefault();
    if (qtyNum <= 0) return toast.error("Alınan miktar 0'dan büyük olmalı");
    if (priceNum < 0) return toast.error("Fiyat negatif olamaz");
    setSaving(true);
    try {
      const { data } = await api.post(`/stock/${item.id}/purchase`, {
        quantity: qtyNum, unit_price: priceNum, supplier: supplier || null, date, notes: notes || null,
      });
      toast.success(`Hızlı alım: +${qtyNum} ${item.unit} eklendi · ${data.cost.toLocaleString("tr-TR")} ₺ gider oluşturuldu`);
      if (data.price_updated) toast.info(`Birim fiyat ${priceNum.toLocaleString("tr-TR")} ₺ olarak güncellendi (fiyat geçmişine işlendi)`);
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
    finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onClose} data-testid="purchase-modal">
      <div className="bg-white rounded-md max-w-lg w-full p-6 max-h-[92vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="flex items-start justify-between mb-4">
          <div>
            <h3 className="heading text-xl flex items-center gap-2 text-[#2D6A4F]"><Plus size={20} weight="bold" /> {item.name} — Hızlı Alım</h3>
            <p className="text-sm text-[#5e675e]">Mevcut: <b className="text-[#1A1D1A]">{Number(item.quantity || 0).toLocaleString("tr-TR")} {item.unit}</b> · Birim fiyat: {Number(item.unit_price || 0).toLocaleString("tr-TR")} ₺</p>
          </div>
          <button onClick={onClose} className="text-2xl text-[#8a938c] hover:text-[#1A1D1A]" data-testid="purchase-modal-close">×</button>
        </div>

        <form onSubmit={submit} className="space-y-3">
          <Field label="Alım Tarihi *"><Input type="date" required value={date} onChange={e => setDate(e.target.value)} data-testid="purchase-date" /></Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label={`Alınan Miktar (${item.unit}) *`}>
              <Input type="number" step="0.01" min="0" required value={quantity} onChange={e => setQuantity(e.target.value)} data-testid="purchase-quantity" placeholder="Örn: 500" autoFocus />
            </Field>
            <Field label="Alış Birim Fiyatı (₺) *">
              <Input type="number" step="0.01" min="0" required value={price} onChange={e => setPrice(e.target.value)} data-testid="purchase-price" />
            </Field>
          </div>
          <Field label="Tedarikçi (opsiyonel)"><Input value={supplier} onChange={e => setSupplier(e.target.value)} data-testid="purchase-supplier" placeholder="Örn: ABC Yem Ltd." /></Field>

          <div className="bg-[#EAF1EC] border border-[#c9d5cc] rounded-md p-4 space-y-1.5 text-sm">
            <div className="flex justify-between"><span>Yeni stok:</span><span className="tabnum font-semibold text-[#2D6A4F]" data-testid="purchase-new-qty">{newQty.toLocaleString("tr-TR")} {item.unit}</span></div>
            <div className="flex justify-between"><span>Alım maliyeti (gider):</span><span className="tabnum font-semibold" data-testid="purchase-cost">{cost.toLocaleString("tr-TR")} ₺</span></div>
            {priceChanged && <div className="text-xs text-[#8B6914]">⚠️ Birim fiyat {Number(item.unit_price || 0).toLocaleString("tr-TR")} → {priceNum.toLocaleString("tr-TR")} ₺ güncellenecek ve fiyat geçmişine yazılacak.</div>}
          </div>

          <Field label="Notlar"><Textarea rows={2} value={notes} onChange={e => setNotes(e.target.value)} data-testid="purchase-notes" placeholder="Örn: irsaliye no 1234" /></Field>

          <div className="flex gap-2 justify-end pt-2">
            <Button type="button" variant="secondary" onClick={onClose}>İptal</Button>
            <Button type="submit" disabled={saving} data-testid="purchase-submit">{saving ? "Kaydediliyor..." : "Alımı Kaydet ve Stoğa Ekle"}</Button>
          </div>
        </form>
      </div>
    </div>
  );
}
